export const findFirstOption = (_, idx) => idx === 0;

export const preventDefault = (event) => event.preventDefault();

export const stopPropagation = (event) => event.stopPropagation();
